const StickyMenu = ( ( window, $, undefined ) => {


  const magic_offset = 134;


	const siteContentWrap = document.querySelector('.site');
	const pageHeader = document.querySelector('.main-header');

	let distanceScrolled;

	const _toggleStickyClass = (e) => {
    distanceScrolled = window.scrollY;

    if ( distanceScrolled > magic_offset){
      helpers.addClass(pageHeader, 'is-sticky');
    } else {
      helpers.removeClass(pageHeader, 'is-sticky');
    }
  };

  const init = () => {
  	if($(window).width()>=1024){
      _toggleStickyClass();
  		window.addEventListener('scroll', _toggleStickyClass);
  	}
  };

  return {
    init: init
  };

})( window, jQuery);